import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import ar from './locales/ar.json';
import en from './locales/en.json';

// i18n configuration
i18n
  .use(LanguageDetector) // Detect the user's language
  .use(initReactI18next) // Bind react-i18next to the i18n instance
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
    },
    fallbackLng: 'ar', // Use Arabic as the fallback language
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage'],
      caches: ['cookie', 'localStorage'],
    },
  });

export default i18n;
